<nz-skeleton [nzActive]="true" *ngIf="isLoading"></nz-skeleton>
<table class="diff-table" *ngIf="!isLoading">
  <thead>
    <tr>
      <th>#</th>
      <th>Date</th>
      <th>Changed Field</th>
      <th>Previous Value</th>
      <th>New Value</th>
      <th>Updated By - User Code</th>
      <th>Updated By - User Name</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let diff of diffEntries; let i = index">

      <!-- Insert blank row if LogInstance changes -->
      <tr *ngIf="i > 0 && diff.LogInstance !== diffEntries[i - 1].LogInstance">
        <td colspan="7" style="height: 10px;"></td>
      </tr>

      <!-- Real data row with conditional blue style -->
      <tr [ngClass]="{'document-lines-row': isDocumentLines(diff)}">
        <td>{{ diff.LogInstance }}</td>
        <td>{{ diff.UpdateDateTime }}</td>
        <td>
          <ng-container *ngIf="isRowAction(diff); else fieldName">
            {{ getRowActionText(diff) }}
          </ng-container>
          <ng-template #fieldName>{{ diff.PropertyName }}</ng-template>
        </td>
        <td>{{ diff.OldValue || '' }}</td>
        <td>{{ diff.NewValue || '' }}</td>
        <td>{{ diff.USER_CODE }}</td>
        <td>{{ diff.U_NAME }}</td>
      </tr>

    </ng-container>
  </tbody>
</table>
